import Page from "../../../components/Page";
import {Container, Grid, Tab, Tabs} from "@material-ui/core";
import React from "react";
import GoogleRecordTable from "./GoogleRecordTable";
import MetaRecordTable from "./MetaRecordTable";
import {HasRole, useTabIndex} from "../../../common/Util";
import {RoleIdEnum} from "../../../generated/graphql";
import LineRecordTable from "./LineRecordTable";

export default () => {
    const [tabIndex, setTabIndex] = useTabIndex();

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };
    return (
        <HasRole roles={[RoleIdEnum.Admin, RoleIdEnum.Pm, RoleIdEnum.PmManager, RoleIdEnum.Gm]}>
        <Page title={"record page"}>
            <Container maxWidth={false} style={{ padding: "30px"}}>
                <Tabs value={tabIndex} onChange={handleChange}>
                    <Tab label="Google報表紀錄" />
                    <Tab label="Meta報表紀錄" />
                    <Tab label="LINE報表紀錄" />
                </Tabs>
                <Grid container spacing={2}>
                    {tabIndex === 0 && <GoogleRecordTable />}
                    {tabIndex === 1 && <MetaRecordTable />}
                    {tabIndex === 2 && <LineRecordTable />}
                </Grid>
            </Container>
        </Page>
        </HasRole>
    )
}